import UtilityAccountsServiceClass from "./UtilityAccountsServiceClass";

export default new UtilityAccountsServiceClass();